import { useState, useEffect, useCallback } from 'react';
import { Company, ActivityFeedItem } from '../types';
import { fetchRecentActivityFeed } from '../services/firestore';

export const useActivityFeed = (companies: Company[]) => {
  const [feedItems, setFeedItems] = useState<ActivityFeedItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const loadFeed = useCallback(async () => {
    if (companies.length === 0) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const items = await fetchRecentActivityFeed(companies);
      setFeedItems(items);
    } catch (err: any) {
      console.warn('[useActivityFeed] Failed to load activity feed:', err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [companies]);

  useEffect(() => {
    loadFeed();
  }, [loadFeed]);

  return { feedItems, loading, error, refreshFeed: loadFeed };
};
